"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OrganizationRenewType;
(function (OrganizationRenewType) {
    OrganizationRenewType["NONE_RENEWING"] = "FBE Non-Renewing";
})(OrganizationRenewType = exports.OrganizationRenewType || (exports.OrganizationRenewType = {}));
/**
 * Firm roster employee invite table CSV headers
 *
 * @category Membership
 */
// Sequence of fields in enum must correspond to sequence of fields in CSV
var FirmRosterEmployeeInviteHeaders;
(function (FirmRosterEmployeeInviteHeaders) {
    FirmRosterEmployeeInviteHeaders["FIRST_NAME"] = "First Name";
    FirmRosterEmployeeInviteHeaders["LAST_NAME"] = "Last Name";
    FirmRosterEmployeeInviteHeaders["EMAIL_ADDRESS"] = "Email Address";
    FirmRosterEmployeeInviteHeaders["PAID_BY_FIRM"] = "Paid by Firm?";
    FirmRosterEmployeeInviteHeaders["POSITION"] = "Position";
    FirmRosterEmployeeInviteHeaders["MEMBERSHIP_TYPE"] = "Membership Type";
    FirmRosterEmployeeInviteHeaders["MEMBERSHIP_TIER"] = "Membership Tier";
    FirmRosterEmployeeInviteHeaders["FLP_SUBSCRIPTION_TYPE"] = "FLP Subscription Type";
    FirmRosterEmployeeInviteHeaders["DATE_INITIATED"] = "Date Initiated";
    FirmRosterEmployeeInviteHeaders["DURATION"] = "Duration";
})(FirmRosterEmployeeInviteHeaders = exports.FirmRosterEmployeeInviteHeaders || (exports.FirmRosterEmployeeInviteHeaders = {}));
/**
 * Firm roster employee invite CIMA table CSV headers
 *
 * @category Membership
 */
// Sequence of fields in enum must correspond to sequence of fields in CSV
var FirmRosterEmployeeInviteCimaHeaders;
(function (FirmRosterEmployeeInviteCimaHeaders) {
    FirmRosterEmployeeInviteCimaHeaders["FIRST_NAME"] = "First Name";
    FirmRosterEmployeeInviteCimaHeaders["LAST_NAME"] = "Last Name";
    FirmRosterEmployeeInviteCimaHeaders["EMAIL_ADDRESS"] = "Email Address";
    FirmRosterEmployeeInviteCimaHeaders["PAID_BY_FIRM"] = "Paid by Organization?";
    FirmRosterEmployeeInviteCimaHeaders["POSITION"] = "Position";
    FirmRosterEmployeeInviteCimaHeaders["MEMBERSHIP_TYPE"] = "Membership Type";
    FirmRosterEmployeeInviteCimaHeaders["MEMBERSHIP_TIER"] = "Membership Tier";
    FirmRosterEmployeeInviteCimaHeaders["FLP_SUBSCRIPTION_TYPE"] = "FLP Subscription Type";
    FirmRosterEmployeeInviteCimaHeaders["DATE_INITIATED"] = "Date Initiated";
    FirmRosterEmployeeInviteCimaHeaders["DURATION"] = "Duration";
})(FirmRosterEmployeeInviteCimaHeaders = exports.FirmRosterEmployeeInviteCimaHeaders || (exports.FirmRosterEmployeeInviteCimaHeaders = {}));
var MembershipSubscriptionStatus;
(function (MembershipSubscriptionStatus) {
    MembershipSubscriptionStatus["NEW"] = "New";
    MembershipSubscriptionStatus["RENEWAL"] = "Renewal";
    MembershipSubscriptionStatus["INVOICED_PAID"] = "Invoiced/Paid";
})(MembershipSubscriptionStatus = exports.MembershipSubscriptionStatus || (exports.MembershipSubscriptionStatus = {}));
/**
 * The Firm Roster Memberhip status.
 *
 * @category Membership
 */
var MembershipStatus;
(function (MembershipStatus) {
    MembershipStatus["ACTIVE"] = "Active";
    MembershipStatus["OVERDUE"] = "Overdue";
    MembershipStatus["LAPSED"] = "Lapsed";
    MembershipStatus["EXPIRED"] = "Expired";
    MembershipStatus["INACTIVE"] = "Inactive";
    MembershipStatus["TERMINATED"] = "Terminated";
    MembershipStatus["PENDING"] = "Pending";
    MembershipStatus["NONE"] = "None";
    MembershipStatus["RESIGNED"] = "Resigned";
})(MembershipStatus = exports.MembershipStatus || (exports.MembershipStatus = {}));
var FLPSubscriptionDurations;
(function (FLPSubscriptionDurations) {
    FLPSubscriptionDurations["SIX_MONTHS"] = "6";
    FLPSubscriptionDurations["TWELVE_MONTHS"] = "12";
    FLPSubscriptionDurations["TWENTY_FOUR_MONTHS"] = "24";
    FLPSubscriptionDurations["THIRTY_SIX_MONTHS"] = "36";
})(FLPSubscriptionDurations = exports.FLPSubscriptionDurations || (exports.FLPSubscriptionDurations = {}));
var ProductNumber;
(function (ProductNumber) {
    ProductNumber["FLP"] = "519";
    ProductNumber["AICPA_FLP"] = "307";
})(ProductNumber = exports.ProductNumber || (exports.ProductNumber = {}));
var FilterExpiryDays;
(function (FilterExpiryDays) {
    FilterExpiryDays["THIRTY_DAYS"] = "30";
    FilterExpiryDays["SIXTY_DAYS"] = "60";
    FilterExpiryDays["NINETY_DAYS"] = "90";
})(FilterExpiryDays = exports.FilterExpiryDays || (exports.FilterExpiryDays = {}));
/* Membership Invite Status.
 *
 * @category Membership
 */
var OktaMembersStatus;
(function (OktaMembersStatus) {
    OktaMembersStatus["ACTIVE"] = "Active";
    OktaMembersStatus["LAPSED"] = "Lapsed";
    OktaMembersStatus["INACTIVE"] = "Inactive";
    OktaMembersStatus["OVERDUE"] = "Overdue";
    OktaMembersStatus["PROVISIONED"] = "PROVISIONED";
})(OktaMembersStatus = exports.OktaMembersStatus || (exports.OktaMembersStatus = {}));
var InviteStatus;
(function (InviteStatus) {
    InviteStatus["PENDING"] = "Pending";
    InviteStatus["AWAITING_RESPONSE"] = "Awaiting Response";
    InviteStatus["ACCEPTED"] = "Accepted";
    InviteStatus["DECLINED"] = "Declined";
    InviteStatus["REMOVED"] = "Removed";
    InviteStatus["REJECTED"] = "Rejected";
})(InviteStatus = exports.InviteStatus || (exports.InviteStatus = {}));
exports.InviteStatusArray = [
    InviteStatus.AWAITING_RESPONSE,
    InviteStatus.ACCEPTED,
    InviteStatus.DECLINED,
    InviteStatus.REMOVED,
];
var FirmBillingQuoteStatus;
(function (FirmBillingQuoteStatus) {
    FirmBillingQuoteStatus["INITIALIZED"] = "Initialized";
    FirmBillingQuoteStatus["QUOTE_IN_PROGRESS"] = "Quote in progress";
    FirmBillingQuoteStatus["QUOTE_GENERATED"] = "Quote generated";
    FirmBillingQuoteStatus["INVOICE_IN_PROGRESS"] = "Invoice in progress";
    FirmBillingQuoteStatus["ERROR"] = "Error";
})(FirmBillingQuoteStatus = exports.FirmBillingQuoteStatus || (exports.FirmBillingQuoteStatus = {}));
var FirmBillingQuoteItemOptions;
(function (FirmBillingQuoteItemOptions) {
    FirmBillingQuoteItemOptions["RESETTABLE"] = "resettable";
    FirmBillingQuoteItemOptions["NOT_RESETTABLE"] = "not-resettable";
    FirmBillingQuoteItemOptions["LOCKED"] = "locked";
    FirmBillingQuoteItemOptions["HIDDEN"] = "hidden";
    FirmBillingQuoteItemOptions["READY"] = "ready";
})(FirmBillingQuoteItemOptions = exports.FirmBillingQuoteItemOptions || (exports.FirmBillingQuoteItemOptions = {}));
var QuoteItemActions;
(function (QuoteItemActions) {
    QuoteItemActions["OWNER"] = "owner";
    QuoteItemActions["QUOTE"] = "quote";
})(QuoteItemActions = exports.QuoteItemActions || (exports.QuoteItemActions = {}));
var MembershipType;
(function (MembershipType) {
    MembershipType["AICPA"] = "AICPA";
    MembershipType["CIMA"] = "CIMA";
    MembershipType["FLP"] = "FLP";
})(MembershipType = exports.MembershipType || (exports.MembershipType = {}));
var AddonType;
(function (AddonType) {
    AddonType["ADD_ON"] = "add-on";
    AddonType["SECTION"] = "section";
    AddonType["CREDENTIAL"] = "credential";
    AddonType["BENEFIT"] = "benefit";
})(AddonType = exports.AddonType || (exports.AddonType = {}));
var AccountPersonAccountRelationshipTypes;
(function (AccountPersonAccountRelationshipTypes) {
    AccountPersonAccountRelationshipTypes["EMPLOYEE"] = "Employee";
    AccountPersonAccountRelationshipTypes["FIRM_BILLING"] = "Firm Billing";
})(AccountPersonAccountRelationshipTypes = exports.AccountPersonAccountRelationshipTypes || (exports.AccountPersonAccountRelationshipTypes = {}));
var OrgStatus;
(function (OrgStatus) {
    OrgStatus["INITIALIZED"] = "initialized";
    OrgStatus["ERROR"] = "error";
})(OrgStatus = exports.OrgStatus || (exports.OrgStatus = {}));
var FLPSubscriptionSlug;
(function (FLPSubscriptionSlug) {
    FLPSubscriptionSlug["SKILLS_CORE"] = "flp-skills-core";
})(FLPSubscriptionSlug = exports.FLPSubscriptionSlug || (exports.FLPSubscriptionSlug = {}));
//# sourceMappingURL=firm-billing-types.js.map